<template>
    <div class="unit-list">
        <div class="unit-item" @click="goDtl(item)" v-for="(item,i) in unitList" :key="i">
            <div class="unit-item-title">
                <p>{{item.areaName}}</p>
                <div class="look">
                    查看详情<img src="./../../static/img/Shape@2x.png" alt="">
                </div>
            </div>
            <div class="unit-left">
                <p class="left-num">{{item.totalUser}}</p>
                <p class="left-title">{{item.areaName}}</p>
            </div>
            <div class="unit-right">
                <div class="right-1">
                    <div class="circle">
                        <chart ref="chart1" :options="item.orgOptions1" :auto-resize="true"></chart>
                        <p style="color:#53C1FF">{{item.learnRate==0?item.learnRate:(item.learnRate/100).toFixed(1)}}%</p>
                    </div>
                    
                    <p>学习</p>
                </div>
                <div class="right-1">
                    <div class="circle">
                        <chart ref="chart1" :options="item.orgOptions2" :auto-resize="true"></chart>
                        <p style="color:#80C269">{{item.communityServiceRate == 0?item.communityServiceRate:(item.communityServiceRate/100).toFixed(1)}}%</p>
                    </div>
                    <p>社区服务</p>
                </div>
                <div class="right-1">
                    <div class="circle">
                        <chart ref="chart1" :options="item.orgOptions3" :auto-resize="true"></chart>
                        <p :style="{color: item.areaType == 5&&item.signFlag?'#ccc':'#F39800'}">{{item.areaType == 5&&item.signFlag==0?'暂未开通':(item.signRate==0?0:(item.signRate/100).toFixed(1))+'%'}}</p>
                    </div>
                    <p>签到</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'GUnit',
    data(){
        return {
        }
    },
    props:['unitList'],
    
    methods:{
        goDtl(item){
            // alert( window.obj.clickUnitDetail(''+item.areaId,item.areaName,Number(item.areaType))9)
            if(this.$plat == 0){
                // alert(999999)
                window.obj.clickUnitDetail(''+item.areaId,item.areaName,Number(item.areaType));
            }else if(this.$plat == 1){
                window.webkit.messageHandlers.clickUnitDetail.postMessage({areaId: item.areaId+'',areaName: item.areaName,areaType: Number(item.areaType)})
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .g-unit{
        width: 100%;
        min-height: 100%;
    }
    .echarts{
        width: 1rem !important;
        height: 1rem;
    }
    .search{
        width: 6.9rem;
        margin: .4rem auto 0;
        background-color: #f2f2f2;
        height: .8rem;
        img{
            float: left;
            width: .3rem;
            margin: .25rem;
        }
        input{
            float: left;
            width: 6rem;
            height: .8rem;
            background-color: transparent;
            font-size: .32rem;
            color: #333
        }
    }
    input::placeholder{
        color: #B1B1B1;
    }
    input:-moz-placeholder{
        color: #B1B1B1;
    }
    input:-ms-input-placeholder{
        color: #B1B1B1
    }
    .unit-title{
        
    }
    .unit-list{
        width: 100%;
        overflow: hidden;
        background-color: #e7e7e7;
        .unit-item{
            width: 100%;
            padding: .2rem .3rem;
            box-sizing: border-box;
            overflow: hidden;
            background-color: #fff;
            margin-bottom: .2rem;
            
        }
        .unit-item-title{
            width: 100%;
            border-bottom: 1px solid #eee;
            height: .8rem;
            line-height: .8rem;
            color: #333333;
            font-size: .32rem;
            p{
                float: left;
            }
            div{
                float: right;
                color: #aaa;
                font-size: .28rem;
                img{
                    width: .16rem;
                    vertical-align: top;
                    margin-left: .2rem;
                    margin-top: .26rem;
                }
            }
        }
        .unit-left{
            float: left;
            .left-num{
                font-size: .4rem;
                color: #666;
                margin-top: .4rem;
            }
            .left-title{
                font-size: .24rem;
                color: #999;
                margin-top: .4rem;
            }
            
        }
        .unit-right{
            float: right;
            height: 100%;
           
            .right-1{
                float: left;
                margin-left: .4rem;
                text-align: center;
                height: 100%;
                p{
                    font-size: .24rem;
                    color: #999999;
                    padding-top: .1rem;
                    box-sizing: border-box;
                }
                .circle{
                    width: 1rem;
                    height: 1rem;
                    position: relative;
                    margin-top: .15rem;
                    &::before{
                        content: '';
                        display: block;
                        width: 6.6rem;
                        height: 2.2rem;
                        opacity: 0;
                        position: absolute;
                        z-index: 999;
                    }
                    p{
                        font-size: .24rem;
                        padding: 0;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/unitList.vue